export enum RoleAccountPermissionEntity {
  ACCOUNT = 'account',
  WORKSPACE = 'workspace',
}
